export const ASSET_BASE_URL = "https://w4xx64my9szilo6f.public.blob.vercel-storage.com";

const assetUrl = path => `${ASSET_BASE_URL}/${path}`;

export const assets = {
  heroPortrait: {
    small: assetUrl("images/anton-rost-portrait-480.webp"),
    medium: assetUrl("images/anton-rost-portrait-800.webp"),
    large: assetUrl("images/anton-rost-portrait-1200.webp")
  },
  resume: {
    de: assetUrl("documents/anton-rost-lebenslauf-2026-de.pdf"),
    en: assetUrl("documents/anton-rost-resume-2026-en.pdf")
  },
  qa: {
    monitoringDetail: assetUrl("images/monitoring-grafana-detail-mock-v4.webp"),
    monitoringHealth: assetUrl("images/monitoring-grafana-health-mock-v4.webp"),
    monitoringWorkflow: assetUrl("images/monitoring-n8n-workflow-mock-v4.webp"),
    webshopFlowDe: assetUrl("images/webshop-ci-flow-de.svg"),
    webshopFlowMobileDe: assetUrl("images/webshop-ci-flow-mobile-de.svg"),
    webshopFlowEn: assetUrl("images/webshop-ci-flow-synthetic.svg"),
    webshopFlowMobileEn: assetUrl("images/webshop-ci-flow-synthetic-mobile.svg"),
    webshopJob: assetUrl("images/webshop-gitlab-job-mock-v4.webp"),
    webshopPipelines: assetUrl("images/webshop-gitlab-pipelines-mock-v4.webp")
  }
};

export function getResumeUrl(locale) {
  return assets.resume[locale] || assets.resume.de;
}
